var JoyUploadSessionType;
(function (JoyUploadSessionType) {
    JoyUploadSessionType["albumCreated"] = "albumCreated";
    JoyUploadSessionType["mediumsAddedToAlbum"] = "mediumsAddedToAlbum";
    JoyUploadSessionType["mediumsAddedToGroup"] = "mediumsAddedToGroup";
})(JoyUploadSessionType || (JoyUploadSessionType = {}));
export default JoyUploadSessionType;
//# sourceMappingURL=JoyUploadSessionType.js.map